export class CoolerStyle {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default CoolerStyle;